import { handleRequest } from "../utilities/requestHandler";
import { authHeader } from "./tokenStore";

export const process2DModelFile = (requestData) =>
    handleRequest("post", "/models/process-2d-modelfile", requestData);

export const processModelFile = (requestData) =>
    handleRequest("post", "/models/process-modelfile", requestData);

// The Bearer token is attached because these URLs live under /models and /stock-models, which
// are served outside the axios instance and now require a session. Without it a 401 reads as
// "the model does not exist" and would silently hide working models.
export const verifyResourceExists = async (url) => {
    if (!url) return false;
    try {
        const response = await fetch(url, { method: "HEAD", redirect: "follow", headers: authHeader() });
        return response.ok || (response.status >= 300 && response.status < 400) || response.redirected;
    } catch (err) {
        console.error("Failed to verify resource:", err);
        return false;
    }
};

/**
 * Asks the server for a short-lived signed URL for one asset path.
 *
 * Needed only where a browser loads an asset by HTML attribute — an `<iframe src>` cannot send
 * an Authorization header, so the signature in the query string is the only way to authenticate
 * that request. Everything that goes through fetch() should use authHeader() instead.
 *
 * @param {string} path Absolute asset path, no origin and no query string.
 * @returns {Promise<string>} The signed query fragment ("exp=...&sig=..."), or "" if the grant
 *   was refused — callers decide whether to fall back or surface an error.
 */
export const getAssetGrant = async (path) => {
    if (!path) return "";
    const response = await handleRequest("post", "/models/asset-grant", { path });
    return response?.status ? response?.data?.query || "" : "";
};
